module.exports = __webpack_public_path__ + "img/find_us_1.13d90125.gif";